import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  private buttonTarget: HTMLElement

  async share() {
    const url = this.buttonTarget.dataset.shareUrl
    if (!url) {
      return
    }
    await navigator.clipboard.writeText(url)
    
    // Show success message using DaisyUI toast
    const toast = document.createElement('div')
    toast.className = 'toast toast-top toast-end'
    toast.innerHTML = `
      <div class="alert alert-success">
        <span>Share URL copied to clipboard!</span>
      </div>
    `
    document.body.appendChild(toast)
    setTimeout(() => toast.remove(), 3000)
  }
} 